// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/registry_records.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { ArchiveVehicleLineageRequest, ArchiveVehicleLineageResponse, AssignEmploymentToSeatRequest, AssignEmploymentToSeatResponse, CreateCompanyDesignationRequest, CreateCompanyDesignationResponse, CreateIntelClaimRequest, CreateIntelClaimResponse, DecideContactEmploymentCandidateRequest, DecideContactEmploymentCandidateResponse, DecideContactMergeCandidateRequest, DecideContactMergeCandidateResponse, DecideRateBurdenBasisRequest, DecideRateBurdenBasisResponse, DecideRatePeriodCoercionRequest, DecideRatePeriodCoercionResponse, DeleteCompanyDesignationRequest, DeleteCompanyDesignationResponse, DeleteOrgSeatRequest, DeleteOrgSeatResponse, GetCompanyDossierRequest, GetCompanyDossierResponse, GetCompanyFamilyRequest, GetCompanyFamilyResponse, GetCompanyRateBookRequest, GetCompanyRateBookResponse, GetContactDossierRequest, GetContactDossierResponse, GetGovernmentOrgAwardSeriesRequest, GetGovernmentOrgAwardSeriesResponse, GetGovernmentOrgDossierRequest, GetGovernmentOrgDossierResponse, GetLaborCategoryAnchorDossierRequest, GetLaborCategoryAnchorDossierResponse, GetPersonCareerPanelRequest, GetPersonCareerPanelResponse, GetRegistryReviewItemRequest, GetRegistryReviewItemResponse, GetVehicleDossierRequest, GetVehicleDossierResponse, GrantSensitiveRatesRequest, GrantSensitiveRatesResponse, LinkRecordDocumentRequest, LinkRecordDocumentResponse, ListAnchorPeopleRequest, ListAnchorPeopleResponse, ListAnchorRatePointsRequest, ListAnchorRatePointsResponse, ListCapabilityRegistrySummariesRequest, ListCapabilityRegistrySummariesResponse, ListCompanyRegistrySummariesRequest, ListCompanyRegistrySummariesResponse, ListContactRegistrySummariesRequest, ListContactRegistrySummariesResponse, ListContactTouchpointsUnifiedRequest, ListContactTouchpointsUnifiedResponse, ListEntityDocumentsRequest, ListEntityDocumentsResponse, ListGovernmentOrgRegistrySummariesRequest, ListGovernmentOrgRegistrySummariesResponse, ListIntelClaimAudienceHistoryRequest, ListIntelClaimAudienceHistoryResponse, ListIntelClaimsRequest, ListIntelClaimsResponse, ListOrganizationPeopleRequest, ListOrganizationPeopleResponse, ListOrgSeatsRequest, ListOrgSeatsResponse, ListPeopleMovesRequest, ListPeopleMovesResponse, ListPersonRateTrailRequest, ListPersonRateTrailResponse, ListRatePeriodCoercionsRequest, ListRatePeriodCoercionsResponse, ListRegistryContractSummariesRequest, ListRegistryContractSummariesResponse, ListRegistryReviewItemsRequest, ListRegistryReviewItemsResponse, ListSensitiveRateGrantsRequest, ListSensitiveRateGrantsResponse, ListVehicleHoldersRequest, ListVehicleHoldersResponse, ListVehicleLineageRequest, ListVehicleLineageResponse, ListVehicleMismatchSignalsRequest, ListVehicleMismatchSignalsResponse, ListVehicleRegistrySummariesRequest, ListVehicleRegistrySummariesResponse, ListVehicleTaskOrderRoundsRequest, ListVehicleTaskOrderRoundsResponse, RegistryRecordServiceSetPricingSheetContractStartRequest, RegistryRecordServiceSetPricingSheetContractStartResponse, RetireOrgSeatRequest, RetireOrgSeatResponse, RetractIntelClaimRequest, RetractIntelClaimResponse, RevokeSensitiveRatesRequest, RevokeSensitiveRatesResponse, SaveOrgSeatRequest, SaveOrgSeatResponse, SaveVehicleLineageRequest, SaveVehicleLineageResponse, SearchLinkableDocumentsRequest, SearchLinkableDocumentsResponse, SetIntelClaimAudienceRequest, SetIntelClaimAudienceResponse, SuggestMappingsForEntryRequest, SuggestMappingsForEntryResponse, UnlinkRecordDocumentRequest, UnlinkRecordDocumentResponse, UpdateCompanyDesignationRequest, UpdateCompanyDesignationResponse, UpdateIntelClaimVerificationRequest, UpdateIntelClaimVerificationResponse } from "./registry_records_pb";
import { MethodKind } from "@bufbuild/protobuf";
import { DecideRegistryMatchCandidateRequest, DecideRegistryMatchCandidateResponse, ListRegistryMatchCandidatesRequest, ListRegistryMatchCandidatesResponse, ListRegistryMergeEventsRequest, ListRegistryMergeEventsResponse, MergeRegistryEntitiesRequest, MergeRegistryEntitiesResponse, ResolveEntitiesRequest, ResolveEntitiesResponse, UnmergeRegistryEntitiesRequest, UnmergeRegistryEntitiesResponse } from "./registry_resolve_pb";
import { GetRegistryIdentifierStatusRequest, GetRegistryIdentifierStatusResponse, SuggestRegistryIdentifiersRequest, SuggestRegistryIdentifiersResponse } from "./registry_identifiers_pb";
import { GetCompanySbaProfileRequest, GetCompanySbaProfileResponse, ListCompanySbaBadgesRequest, ListCompanySbaBadgesResponse, SearchSbaMentorProtegeAgreementsRequest, SearchSbaMentorProtegeAgreementsResponse } from "./registry_sba_pb";
/**
 * Browser service. Tenant and actor come exclusively from the gateway
 * principal. Reads require registry membership (an authenticated principal of a
 * real tenant — the population that can open today's Registries tabs); every
 * program/pursuit-derived count is computed over rows the caller may read with
 * ViewMode Full (counts never leak); Growth-sensitive content additionally needs
 * capture_project view_sensitive; delivery touchpoints need program area:growth.
 * Person-scoped money is never returned except by ListPersonRateTrail.
 *
 * @generated from service mono.datagateway.v1.RegistryRecordService
 */ export const RegistryRecordService = {
    typeName: "mono.datagateway.v1.RegistryRecordService",
    methods: {
        /**
     * ---- Registries list summaries (REG-05, REG-06) ----
     *
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.ListCompanyRegistrySummaries
     */ listCompanyRegistrySummaries: {
            name: "ListCompanyRegistrySummaries",
            I: ListCompanyRegistrySummariesRequest,
            O: ListCompanyRegistrySummariesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.ListContactRegistrySummaries
     */ listContactRegistrySummaries: {
            name: "ListContactRegistrySummaries",
            I: ListContactRegistrySummariesRequest,
            O: ListContactRegistrySummariesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.ListGovernmentOrgRegistrySummaries
     */ listGovernmentOrgRegistrySummaries: {
            name: "ListGovernmentOrgRegistrySummaries",
            I: ListGovernmentOrgRegistrySummariesRequest,
            O: ListGovernmentOrgRegistrySummariesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.ListVehicleRegistrySummaries
     */ listVehicleRegistrySummaries: {
            name: "ListVehicleRegistrySummaries",
            I: ListVehicleRegistrySummariesRequest,
            O: ListVehicleRegistrySummariesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.ListRegistryContractSummaries
     */ listRegistryContractSummaries: {
            name: "ListRegistryContractSummaries",
            I: ListRegistryContractSummariesRequest,
            O: ListRegistryContractSummariesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.ListCapabilityRegistrySummaries
     */ listCapabilityRegistrySummaries: {
            name: "ListCapabilityRegistrySummaries",
            I: ListCapabilityRegistrySummariesRequest,
            O: ListCapabilityRegistrySummariesResponse,
            kind: MethodKind.Unary
        },
        /**
     * ---- Person (REG-10) ----
     *
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.GetContactDossier
     */ getContactDossier: {
            name: "GetContactDossier",
            I: GetContactDossierRequest,
            O: GetContactDossierResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.ListContactTouchpointsUnified
     */ listContactTouchpointsUnified: {
            name: "ListContactTouchpointsUnified",
            I: ListContactTouchpointsUnifiedRequest,
            O: ListContactTouchpointsUnifiedResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.ListEntityDocuments
     */ listEntityDocuments: {
            name: "ListEntityDocuments",
            I: ListEntityDocumentsRequest,
            O: ListEntityDocumentsResponse,
            kind: MethodKind.Unary
        },
        /**
     * REG-49
     *
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.LinkRecordDocument
     */ linkRecordDocument: {
            name: "LinkRecordDocument",
            I: LinkRecordDocumentRequest,
            O: LinkRecordDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * REG-49
     *
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.UnlinkRecordDocument
     */ unlinkRecordDocument: {
            name: "UnlinkRecordDocument",
            I: UnlinkRecordDocumentRequest,
            O: UnlinkRecordDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * REG-49
     *
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.SearchLinkableDocuments
     */ searchLinkableDocuments: {
            name: "SearchLinkableDocuments",
            I: SearchLinkableDocumentsRequest,
            O: SearchLinkableDocumentsResponse,
            kind: MethodKind.Unary
        },
        /**
     * ---- Company (REG-13, REG-14) ----
     *
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.GetCompanyDossier
     */ getCompanyDossier: {
            name: "GetCompanyDossier",
            I: GetCompanyDossierRequest,
            O: GetCompanyDossierResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.GetCompanyRateBook
     */ getCompanyRateBook: {
            name: "GetCompanyRateBook",
            I: GetCompanyRateBookRequest,
            O: GetCompanyRateBookResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.ListOrganizationPeople
     */ listOrganizationPeople: {
            name: "ListOrganizationPeople",
            I: ListOrganizationPeopleRequest,
            O: ListOrganizationPeopleResponse,
            kind: MethodKind.Unary
        },
        /**
     * REG-62
     *
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.GetCompanyFamily
     */ getCompanyFamily: {
            name: "GetCompanyFamily",
            I: GetCompanyFamilyRequest,
            O: GetCompanyFamilyResponse,
            kind: MethodKind.Unary
        },
        /**
     * SAD-1333: hand-set company roles (PARTNER). Writes need area:registries;
     * created_by is the caller and every write is an operational audit event.
     *
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.CreateCompanyDesignation
     */ createCompanyDesignation: {
            name: "CreateCompanyDesignation",
            I: CreateCompanyDesignationRequest,
            O: CreateCompanyDesignationResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.UpdateCompanyDesignation
     */ updateCompanyDesignation: {
            name: "UpdateCompanyDesignation",
            I: UpdateCompanyDesignationRequest,
            O: UpdateCompanyDesignationResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.DeleteCompanyDesignation
     */ deleteCompanyDesignation: {
            name: "DeleteCompanyDesignation",
            I: DeleteCompanyDesignationRequest,
            O: DeleteCompanyDesignationResponse,
            kind: MethodKind.Unary
        },
        /**
     * ---- Labor category (REG-18) ----
     *
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.GetLaborCategoryAnchorDossier
     */ getLaborCategoryAnchorDossier: {
            name: "GetLaborCategoryAnchorDossier",
            I: GetLaborCategoryAnchorDossierRequest,
            O: GetLaborCategoryAnchorDossierResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.ListAnchorRatePoints
     */ listAnchorRatePoints: {
            name: "ListAnchorRatePoints",
            I: ListAnchorRatePointsRequest,
            O: ListAnchorRatePointsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.ListAnchorPeople
     */ listAnchorPeople: {
            name: "ListAnchorPeople",
            I: ListAnchorPeopleRequest,
            O: ListAnchorPeopleResponse,
            kind: MethodKind.Unary
        },
        /**
     * REG-50: "Ask for suggestions" on the entry page. Waits up to 10 s for the run.
     *
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.SuggestMappingsForEntry
     */ suggestMappingsForEntry: {
            name: "SuggestMappingsForEntry",
            I: SuggestMappingsForEntryRequest,
            O: SuggestMappingsForEntryResponse,
            kind: MethodKind.Unary
        },
        /**
     * ---- Vehicle (REG-21, REG-22) ----
     *
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.GetVehicleDossier
     */ getVehicleDossier: {
            name: "GetVehicleDossier",
            I: GetVehicleDossierRequest,
            O: GetVehicleDossierResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.ListVehicleHolders
     */ listVehicleHolders: {
            name: "ListVehicleHolders",
            I: ListVehicleHoldersRequest,
            O: ListVehicleHoldersResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.ListVehicleTaskOrderRounds
     */ listVehicleTaskOrderRounds: {
            name: "ListVehicleTaskOrderRounds",
            I: ListVehicleTaskOrderRoundsRequest,
            O: ListVehicleTaskOrderRoundsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.ListVehicleMismatchSignals
     */ listVehicleMismatchSignals: {
            name: "ListVehicleMismatchSignals",
            I: ListVehicleMismatchSignalsRequest,
            O: ListVehicleMismatchSignalsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.ListVehicleLineage
     */ listVehicleLineage: {
            name: "ListVehicleLineage",
            I: ListVehicleLineageRequest,
            O: ListVehicleLineageResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.SaveVehicleLineage
     */ saveVehicleLineage: {
            name: "SaveVehicleLineage",
            I: SaveVehicleLineageRequest,
            O: SaveVehicleLineageResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.ArchiveVehicleLineage
     */ archiveVehicleLineage: {
            name: "ArchiveVehicleLineage",
            I: ArchiveVehicleLineageRequest,
            O: ArchiveVehicleLineageResponse,
            kind: MethodKind.Unary
        },
        /**
     * ---- Government org (REG-24) ----
     *
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.GetGovernmentOrgDossier
     */ getGovernmentOrgDossier: {
            name: "GetGovernmentOrgDossier",
            I: GetGovernmentOrgDossierRequest,
            O: GetGovernmentOrgDossierResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.GetGovernmentOrgAwardSeries
     */ getGovernmentOrgAwardSeries: {
            name: "GetGovernmentOrgAwardSeries",
            I: GetGovernmentOrgAwardSeriesRequest,
            O: GetGovernmentOrgAwardSeriesResponse,
            kind: MethodKind.Unary
        },
        /**
     * ---- Hearsay (REG-02) ----
     *
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.CreateIntelClaim
     */ createIntelClaim: {
            name: "CreateIntelClaim",
            I: CreateIntelClaimRequest,
            O: CreateIntelClaimResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.ListIntelClaims
     */ listIntelClaims: {
            name: "ListIntelClaims",
            I: ListIntelClaimsRequest,
            O: ListIntelClaimsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.UpdateIntelClaimVerification
     */ updateIntelClaimVerification: {
            name: "UpdateIntelClaimVerification",
            I: UpdateIntelClaimVerificationRequest,
            O: UpdateIntelClaimVerificationResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.RetractIntelClaim
     */ retractIntelClaim: {
            name: "RetractIntelClaim",
            I: RetractIntelClaimRequest,
            O: RetractIntelClaimResponse,
            kind: MethodKind.Unary
        },
        /**
     * v2.2 (I-11): per-claim audience (author only) and its history.
     *
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.SetIntelClaimAudience
     */ setIntelClaimAudience: {
            name: "SetIntelClaimAudience",
            I: SetIntelClaimAudienceRequest,
            O: SetIntelClaimAudienceResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.ListIntelClaimAudienceHistory
     */ listIntelClaimAudienceHistory: {
            name: "ListIntelClaimAudienceHistory",
            I: ListIntelClaimAudienceHistoryRequest,
            O: ListIntelClaimAudienceHistoryResponse,
            kind: MethodKind.Unary
        },
        /**
     * ---- Review queue (REG-26..REG-29) ----
     *
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.ListRegistryReviewItems
     */ listRegistryReviewItems: {
            name: "ListRegistryReviewItems",
            I: ListRegistryReviewItemsRequest,
            O: ListRegistryReviewItemsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.GetRegistryReviewItem
     */ getRegistryReviewItem: {
            name: "GetRegistryReviewItem",
            I: GetRegistryReviewItemRequest,
            O: GetRegistryReviewItemResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.DecideContactMergeCandidate
     */ decideContactMergeCandidate: {
            name: "DecideContactMergeCandidate",
            I: DecideContactMergeCandidateRequest,
            O: DecideContactMergeCandidateResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.DecideContactEmploymentCandidate
     */ decideContactEmploymentCandidate: {
            name: "DecideContactEmploymentCandidate",
            I: DecideContactEmploymentCandidateRequest,
            O: DecideContactEmploymentCandidateResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.ListRatePeriodCoercions
     */ listRatePeriodCoercions: {
            name: "ListRatePeriodCoercions",
            I: ListRatePeriodCoercionsRequest,
            O: ListRatePeriodCoercionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.DecideRatePeriodCoercion
     */ decideRatePeriodCoercion: {
            name: "DecideRatePeriodCoercion",
            I: DecideRatePeriodCoercionRequest,
            O: DecideRatePeriodCoercionResponse,
            kind: MethodKind.Unary
        },
        /**
     * REG-26
     *
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.SetPricingSheetContractStart
     */ setPricingSheetContractStart: {
            name: "SetPricingSheetContractStart",
            I: RegistryRecordServiceSetPricingSheetContractStartRequest,
            O: RegistryRecordServiceSetPricingSheetContractStartResponse,
            kind: MethodKind.Unary
        },
        /**
     * REG-42
     *
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.DecideRateBurdenBasis
     */ decideRateBurdenBasis: {
            name: "DecideRateBurdenBasis",
            I: DecideRateBurdenBasisRequest,
            O: DecideRateBurdenBasisResponse,
            kind: MethodKind.Unary
        },
        /**
     * ---- People movement (REG-31, REG-32) ----
     *
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.ListOrgSeats
     */ listOrgSeats: {
            name: "ListOrgSeats",
            I: ListOrgSeatsRequest,
            O: ListOrgSeatsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.SaveOrgSeat
     */ saveOrgSeat: {
            name: "SaveOrgSeat",
            I: SaveOrgSeatRequest,
            O: SaveOrgSeatResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.RetireOrgSeat
     */ retireOrgSeat: {
            name: "RetireOrgSeat",
            I: RetireOrgSeatRequest,
            O: RetireOrgSeatResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.DeleteOrgSeat
     */ deleteOrgSeat: {
            name: "DeleteOrgSeat",
            I: DeleteOrgSeatRequest,
            O: DeleteOrgSeatResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.AssignEmploymentToSeat
     */ assignEmploymentToSeat: {
            name: "AssignEmploymentToSeat",
            I: AssignEmploymentToSeatRequest,
            O: AssignEmploymentToSeatResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.ListPeopleMoves
     */ listPeopleMoves: {
            name: "ListPeopleMoves",
            I: ListPeopleMovesRequest,
            O: ListPeopleMovesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.GetPersonCareerPanel
     */ getPersonCareerPanel: {
            name: "GetPersonCareerPanel",
            I: GetPersonCareerPanelRequest,
            O: GetPersonCareerPanelResponse,
            kind: MethodKind.Unary
        },
        /**
     * ---- Comp vault foundation (REG-34, REG-35) ----
     *
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.ListPersonRateTrail
     */ listPersonRateTrail: {
            name: "ListPersonRateTrail",
            I: ListPersonRateTrailRequest,
            O: ListPersonRateTrailResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.ListSensitiveRateGrants
     */ listSensitiveRateGrants: {
            name: "ListSensitiveRateGrants",
            I: ListSensitiveRateGrantsRequest,
            O: ListSensitiveRateGrantsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.GrantSensitiveRates
     */ grantSensitiveRates: {
            name: "GrantSensitiveRates",
            I: GrantSensitiveRatesRequest,
            O: GrantSensitiveRatesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.RevokeSensitiveRates
     */ revokeSensitiveRates: {
            name: "RevokeSensitiveRates",
            I: RevokeSensitiveRatesRequest,
            O: RevokeSensitiveRatesResponse,
            kind: MethodKind.Unary
        },
        /**
     * ---- Shared entity resolver, browser/Assist twins (REG-54 part B; messages in
     * registry_resolve.proto). Tenant and actor come from the principal; request
     * tenant_id / actor_* fields are ignored. ----
     *
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.ResolveEntities
     */ resolveEntities: {
            name: "ResolveEntities",
            I: ResolveEntitiesRequest,
            O: ResolveEntitiesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.ListRegistryMatchCandidates
     */ listRegistryMatchCandidates: {
            name: "ListRegistryMatchCandidates",
            I: ListRegistryMatchCandidatesRequest,
            O: ListRegistryMatchCandidatesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.DecideRegistryMatchCandidate
     */ decideRegistryMatchCandidate: {
            name: "DecideRegistryMatchCandidate",
            I: DecideRegistryMatchCandidateRequest,
            O: DecideRegistryMatchCandidateResponse,
            kind: MethodKind.Unary
        },
        /**
     * ---- Merge (REG-55; messages in registry_resolve.proto) ----
     *
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.MergeRegistryEntities
     */ mergeRegistryEntities: {
            name: "MergeRegistryEntities",
            I: MergeRegistryEntitiesRequest,
            O: MergeRegistryEntitiesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.UnmergeRegistryEntities
     */ unmergeRegistryEntities: {
            name: "UnmergeRegistryEntities",
            I: UnmergeRegistryEntitiesRequest,
            O: UnmergeRegistryEntitiesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.ListRegistryMergeEvents
     */ listRegistryMergeEvents: {
            name: "ListRegistryMergeEvents",
            I: ListRegistryMergeEventsRequest,
            O: ListRegistryMergeEventsResponse,
            kind: MethodKind.Unary
        },
        /**
     * ---- Strong-ID suggestions (REG-61 part A; messages in registry_identifiers.proto) ----
     *
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.SuggestRegistryIdentifiers
     */ suggestRegistryIdentifiers: {
            name: "SuggestRegistryIdentifiers",
            I: SuggestRegistryIdentifiersRequest,
            O: SuggestRegistryIdentifiersResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.GetRegistryIdentifierStatus
     */ getRegistryIdentifierStatus: {
            name: "GetRegistryIdentifierStatus",
            I: GetRegistryIdentifierStatusRequest,
            O: GetRegistryIdentifierStatusResponse,
            kind: MethodKind.Unary
        },
        /**
     * ---- SBA public data (DAT-25; messages in registry_sba.proto) ----
     *
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.GetCompanySbaProfile
     */ getCompanySbaProfile: {
            name: "GetCompanySbaProfile",
            I: GetCompanySbaProfileRequest,
            O: GetCompanySbaProfileResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.ListCompanySbaBadges
     */ listCompanySbaBadges: {
            name: "ListCompanySbaBadges",
            I: ListCompanySbaBadgesRequest,
            O: ListCompanySbaBadgesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.datagateway.v1.RegistryRecordService.SearchSbaMentorProtegeAgreements
     */ searchSbaMentorProtegeAgreements: {
            name: "SearchSbaMentorProtegeAgreements",
            I: SearchSbaMentorProtegeAgreementsRequest,
            O: SearchSbaMentorProtegeAgreementsResponse,
            kind: MethodKind.Unary
        }
    }
};
